import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Header, Paper } from '../components';
import Button from '../components/Button';
import * as React from 'react';
const NewAccount = () => {
    return (_jsxs(Paper, { children: [_jsx(Header, Object.assign({ id: 'new-account-header' }, { children: "NY KUND HOS OSS?" })), _jsx("p", Object.assign({ style: {
                    marginBottom: '16px',
                    fontSize: '14px',
                } }, { children: "Om du \u00E4r ny kund hos oss kan du ans\u00F6ka om ett konto genom att klicka p\u00E5 knappen nedan." })), _jsx(Button, Object.assign({ "aria-labelledby": 'new-account-header', "aria-describedby": 'new-account-description' }, { children: "ANSOK IDAG" })), _jsx("span", Object.assign({ id: 'new-account-description', style: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: '0',
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0,0,0,0)',
                    whiteSpace: 'nowrap',
                    border: '0',
                } }, { children: "Klicka f\u00F6r att ans\u00F6ka om ett nytt kundkonto hos oss" }))] }));
};
export default NewAccount;
